import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo, useState, useEffect } from 'react';
import 'prop-types';
import PanelSteps from '../PanelSteps/PanelSteps.js';

const PanelKeys = ({
  children,
  step,
  ...props
}) => {
  const arrayChildren = useMemo(() => React.Children.toArray(children), [children]);
  const childrenKeys = useMemo(() => React.Children.map(children, child => child.key), [children]);
  const [index, setIndex] = useState(step ? childrenKeys.indexOf(step) : 0);
  useEffect(() => {
    if (!step) return;
    const keyIndex = childrenKeys.indexOf(step);
    setIndex(keyIndex > -1 ? keyIndex : 0);
  }, [step]);
  if (!step) {
    return null;
  }
  return /*#__PURE__*/React.createElement(PanelSteps, _extends({
    step: index
  }, props), arrayChildren);
};
PanelKeys.defaultProps = {
  color: 'primary',
  size: 'md',
  align: '',
  timeout: 300,
  axis: 'X',
  travel: 300,
  duration: 0.5,
  step: 0,
  ease: 'easeInOutCubic'
};

export { PanelKeys as default };
